import React, { useEffect, useState } from "react";
import "../css/Payement.css";
import AdminSideBar from "../../layouts/AdminSideBar";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import LoadingPage from "../../layouts/Loading";

export default function PaymentsList() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPayments = async () => {
    try {
      const response = await fetch(
        "http://127.0.0.1:8000/medicine/payments/get/"
      );
      const data = await response.json();
      setPayments(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching payments:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  /* ---------------- HELPER FUNCTIONS ---------------- */
  // Table: full card number, 4-4-4-4
  const formatCardNumberForTable = (number) => {
    if (!number) return "-";
    return String(number).replace(/(\d{4})(?=\d)/g, "$1 ");
  };

  /* ---------------- PDF FUNCTION ---------------- */
  const downloadPaymentsPDF = () => {
    if (!payments.length) {
      alert("No payment data available!");
      return;
    }

    const doc = new jsPDF();

    // Header
    doc.setFontSize(20);
    doc.setFont("helvetica", "bold");
    doc.text("MediCare Store", 14, 15);

    doc.setFontSize(12);
    doc.text("Payments Report", 14, 25);
    doc.line(14, 28, 195, 28);

    // Payments Table in PDF
    autoTable(doc, {
      startY: 35,
      theme: "grid",
      headStyles: { fillColor: [0, 150, 136] },
      head: [
        ["ID", "Name on Card", "Card Number", "Expiry", "CVV", "Created At"],
      ],
      body: payments.map((p) => [
        p.id ?? "-",
        p.name_on_card ?? "-",
        formatCardNumberForTable(p.card_number), // masked for PDF
        p.expiry_date ?? "-",
        p.cvv ?? "-",
        p.created_at ? String(p.created_at).slice(0, 10) : "-",
      ]),
    });

    // Footer
    const Y = doc.lastAutoTable.finalY + 15;
    doc.setFontSize(12);
    doc.text("Admin Report - MediCare Store", 14, Y);
    doc.setFontSize(10);
    doc.text("Generated by: Admin", 14, Y + 6);
    doc.text("Contact: admin@medicare.pk | +92-342-0339016", 14, Y + 12);
    doc.text("Address: Main Road, City Center, Pakistan", 14, Y + 18);
    doc.setFontSize(9);
    doc.text("© 2025 MediCare Store", 14, Y + 25);

    doc.save("Payments_Admin_Report.pdf");
  };

  if (loading) return <LoadingPage />;

  return (
    <div className="app-container">
      <AdminSideBar />
      <div className="main-panel">
        <div className="max-width-container">
          <h2 className="page-title">Payments</h2>

          {/* Download PDF Button */}
          <button onClick={downloadPaymentsPDF} className="download-btn">
            Download Payments PDF
          </button>

          <div className="table-card">
            <table className="styled-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name on Card</th>
                  <th>Card Number</th>
                  <th>Expiry</th>
                  <th>CVV</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {payments.map((p) => (
                  <tr key={p.id}>
                    <td>{p.id}</td>
                    <td>{p.name_on_card}</td>
                    <td>{formatCardNumberForTable(p.card_number)}</td>{" "}
                    {/* formatted */}
                    <td>{p.expiry_date}</td>
                    <td>{p.cvv}</td>
                    <td>{p.created_at}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
